module.exports = __webpack_public_path__ + "static/media/5.23d984d0.jpg";